import { Link } from "react-router-dom";
import { brandLogoWide } from "../../../../utils";

const HeaderLayout3 = ({ admissionImg }) => {
  return (
    <div className="logo-area">
      <div className="row g-3 g-md-0 align-items-center">
        <div className="col-md-6 p-0 m-0 text-start">
          <Link to="/" className="logo-link">
            <img
              src={brandLogoWide()}
              alt="Logo"
              className="img-fluid"
              style={{
                width: "100%",
                maxWidth: admissionImg > 0 ? admissionImg + "px" : "100%",
              }}
            />
          </Link>
        </div>

        <div className="col-md-6 h-100 text-end">
          <div className="d-flex align-items-center justify-content-end gap-3">
            <div className="text-start me-4 d-none d-lg-block">
              <div className="fs-10 text-muted fw-800">PORTAL ACCESS</div>
              <div className="fs-12 fw-bold text-dark">
                GO TO LOGIN{" "}
                <i className="fa-solid fa-arrow-right ms-1 small opacity-50"></i>
              </div>
            </div>
            <Link to="/sign-in" className="header-tile border shadow-sm">
              <i className="fa-solid fa-lock"></i>
              <span>SIGN IN</span>
            </Link>
            <Link
              to="/sign-up"
              className="header-tile bg-main-theme text-white shadow-sm"
            >
              <i className="fa-solid fa-user-plus text-white"></i>
              <span className="text-white">REGISTER</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderLayout3;
